import { defineComponent as _defineComponent } from 'vue'
import "cropperjs/dist/cropper.css"

import { message } from "ant-design-vue"
import { computed, onMounted, reactive, ref, watch } from "vue"
import VueCropper from "vue-cropperjs"

type CroppedImageDetails = { detail: Record<string, number> }
type Props = {
  visible: boolean
  croppedImage?: Record<string, string | File>
}
type Emits = {
  (event: "onCropped", image: Blob): void
  (event: "close"): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageCropper',
  props: {
    visible: { type: Boolean },
    croppedImage: null
  },
  emits: ["onCropped", "close"],
  setup(__props: any, { emit }: { emit: ({
  (event: "onCropped", image: Blob): void
  (event: "close"): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  visible: boolean
  croppedImage?: Record<string, string | File>
};




const cropperRef = ref<typeof VueCropper>()
const isPending = ref<boolean>(false)
const imageSize = reactive({
  width: 0,
  height: 0
})

const disableCrop = computed(() => imageSize.width < 500 || imageSize.height < 500)

const calculateSizes = (imageInfo: CroppedImageDetails) => {
  imageSize.width = Math.round(imageInfo.detail.width)
  imageSize.height = Math.round(imageInfo.detail.height)
}
const rotate = () => {
  cropperRef.value.rotate(90)
}
const initCropper = async () => {
  if (!cropperRef.value) return

  if (!props.visible) {
    cropperRef.value.replace(undefined)
    return
  }

  try {
    const response = await fetch(props.croppedImage.preview as string, {
      method: "GET",
      mode: "cors"
    })

    const reader = new FileReader()
    reader.onload = (e) => {
      if (cropperRef.value) {
        cropperRef.value.replace(e.target!.result)
      }
    }
    reader.readAsDataURL(await response.blob())
  } catch (error) {
    message.error(error)
  }
}
const onSubmit = async () => {
  isPending.value = true

  cropperRef.value.getCroppedCanvas().toBlob(async (blob: Blob) => {
    isPending.value = false

    const imageFormat = props.croppedImage.format

    emit(
      "onCropped",
      new File([blob], `${self.crypto.randomUUID()}.${imageFormat}`, {
        type: `image/${imageFormat}`
      })
    )
  })
}
const handleClose = () => {
  emit("close")
}

watch(() => props.visible, initCropper)

onMounted(initCropper)

return { __sfc: true,props, emit, cropperRef, isPending, imageSize, disableCrop, calculateSizes, rotate, initCropper, onSubmit, handleClose, VueCropper }
}

})